import { useParams } from '@tanstack/react-router';
import { useInfluencerProfileV2Query } from '@anytag/graphql';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { useQueryHelper } from '@anytag/shared-hooks';
import { Template } from './template';

export const InfluencerProfile = () => {
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const params = useParams({ strict: false });
  const { data, loading } = useInfluencerProfileV2Query({
    skip: !params.id,
    variables: { pk: Number(params.id) },
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
      navigate({ to: '/influencers' });
    }
  });

  const influencerProfile = data?.influencerProfileV2;

  return (
    <RenderDataWithFallback loading={loading} hasNoData={!influencerProfile}>
      {influencerProfile ? <Template influencerProfile={influencerProfile} /> : null}
    </RenderDataWithFallback>
  );
};
